import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  alert: {
    padding: '16px',
    margin: '16px 0',
    borderRadius: '4px',
    textAlign: 'center',
    fontWeight: 'bold',
    width: '100%',
  },
  error: {
    backgroundColor: '#f8d7da',
    color: '#721c24',
    border: '1px solid #f5c6cb',
  },
  warning: {
    backgroundColor: '#fff3cd',
    color: '#856404',
    border: '1px solid #ffeeba',
  },
  info: {
    backgroundColor: '#d1ecf1',
    color: '#0c5460',
    border: '1px solid #bee5eb',
  },
  success: {
    backgroundColor: '#d4edda',
    color: '#155724',
    border: '1px solid #c3e6cb',
  },
}));

const Alert = ({ severity, message }) => {
  const classes = useStyles();
  if (!message) return null;
  return <div className={`${classes.alert} ${classes[severity]}`}>{message}</div>;
};

Alert.propTypes = {
  severity: PropTypes.oneOf(['error', 'warning', 'info', 'success']).isRequired,
  message: PropTypes.string,
};

export default Alert;
